<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
  @if (data.printType === 'label') {
    <form [formGroup]="printLabelsForm">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Client name</mat-label>
          <input required data-testid="client-name" type="text" placeholder="Client name" matInput
            formControlName="client">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Prescriber name</mat-label>
            <input required data-testid="prescriber-name" type="text" placeholder="Prescriber name" matInput
              formControlName="prescriber">
            </mat-form-field>
          </p>
          <p>
            <mat-checkbox [checked]="largeSize" (change)="largeSize = !largeSize" color="primary">Large size</mat-checkbox>
          </p>
        </form>
      }

    </div>
    <div mat-dialog-actions align="end">
      <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
      @if (data.printType === 'barcode') {
        <button mat-raised-button (click)="print()" color="primary"
        cdkFocusInitial>Print</button>
      }
      @if (data.printType === 'label') {
        <button [disabled]="printLabelsForm.invalid" mat-raised-button (click)="print()"
        color="primary" cdkFocusInitial>Print</button>
      }
    </div>